import type { Navigation } from '@twisto/api-cms'

import { PrimaryComponents } from './components/primary-components'
import * as styles from './primary-navigation-slot.styles'

type Props = {
  primaryNavigationContent: Navigation['primary']
}
export const PrimaryNavigationSlot = ({ primaryNavigationContent }: Props) => (
  <ul css={styles.primaryNavigationSlot}>
    <PrimaryComponents primaryNavigationContent={primaryNavigationContent} />
  </ul>
)
